// @flow strict
export type CabinClassType = "economy" | "business" | "first" | "premium"

export type CabinClass = {|
  type: CabinClassType,
  allowMixed: boolean,
|}

export const CABIN_CLASS = {
  economy: __("form_search.cabin_class.economy"),
  premium: __("form_search.cabin_class.premium"),
  business: __("form_search.cabin_class.business"),
  first: __("form_search.cabin_class.first"),
}

export const DEFAULT_CABIN_CLASS_TYPE: CabinClassType = "economy"
export const DEFAULT_CABIN_CLASS: CabinClass = {
  type: DEFAULT_CABIN_CLASS_TYPE,
  allowMixed: true,
}

export const cabinClassToQuery = (cabinClass: CabinClass) =>
  `${cabinClass.type}-${cabinClass.allowMixed.toString()}`
